export const GET_LOG_TDS = 'GET_LOG_TDS';
export const GET_LOG_TDS_SUCCESS = 'GET_LOG_TDS_SUCCESS';
export const GET_LOG_TDS_FAILED = 'GET_LOG_TDS_FAILED';

export const GET_LOG_TDS_BY_ID = 'GET_LOG_TDS_BY_ID';
export const GET_LOG_TDS_BY_ID_SUCCESS = 'GET_LOG_TDS_BY_ID_SUCCESS';
export const GET_LOG_TDS_BY_ID_FAILED = 'GET_LOG_TDS_BY_ID_FAILED';

export const ADD_LOG_TDS = 'ADD_LOG_TDS';
export const ADD_LOG_TDS_SUCCESS = 'ADD_LOG_TDS_SUCCESS';
export const ADD_LOG_TDS_FAILED = 'ADD_LOG_TDS_FAILED';

export const UPDATE_LOG_TDS = 'UPDATE_LOG_TDS';
export const UPDATE_LOG_TDS_SUCCESS = 'UPDATE_LOG_TDS_SUCCESS';
export const UPDATE_LOG_TDS_FAILED = 'UPDATE_LOG_TDS_FAILED';

export const DELETE_LOG_TDS = 'DELETE_LOG_TDS';
export const DELETE_LOG_TDS_SUCCESS = 'DELETE_LOG_TDS_SUCCESS';
export const DELETE_LOG_TDS_FAILED = 'DELETE_LOG_TDS_FAILED';
